import { Viewstates } from "@vattenfall/core";

import { ChatAppMessageType, ChatAppElementModel } from "./chat-app.model";

export const VIEWSTATES: Viewstates<ChatAppElementModel> = {
  closed: {
    action: "closed",
    open: false,
  },
  unread: {
    action: "unread",
    open: false,
    unreadMessageCount: 5,
  },
  open: {
    action: "open",
    open: true,
  },
  loading: {
    action: "loading",
    open: true,
    loading: true,
    messages: [
      {
        messageType: ChatAppMessageType.Bot,
        message: "Hello, please ask your question directly in the chat!",
        timestamp: new Date(new Date().getTime() - 1000 * 60 * 5),
      },
      {
        messageType: ChatAppMessageType.Bot,
        message: "Please keep in mind not to share personal information unless I ask for it.",
        timestamp: new Date(new Date().getTime() - 1000 * 15),
      },
      {
        messageType: ChatAppMessageType.User,
        message: "Ok sure I'll try.",
        timestamp: new Date(new Date().getTime() - 1000 * 12),
      },
    ],
  },
  error: {
    action: "error",
    open: true,
    error: true,
  },
  dialog: {
    action: "dialog",
    open: true,
    messages: [
      {
        messageType: ChatAppMessageType.Bot,
        message: "Hello, please ask your question directly in the chat!",
        timestamp: new Date(new Date().getTime() - 1000 * 60 * 5),
      },
      {
        messageType: ChatAppMessageType.Bot,
        message: "Please keep in mind not to share personal information unless I ask for it.",
        timestamp: new Date(new Date().getTime() - 1000 * 60 * 5),
      },
      {
        messageType: ChatAppMessageType.User,
        message: "Ok, I have a question about my electricity bill.",
        timestamp: new Date(new Date().getTime() - 1000 * 60 * 4),
      },
      {
        messageType: ChatAppMessageType.Bot,
        message: "Alright, what's the question?",
        timestamp: new Date(new Date().getTime() - 1000 * 60 * 4),
      },
    ],
  },
  agent: {
    action: "agent",
    open: true,
    messages: [
      {
        messageType: ChatAppMessageType.Agent,
        message: "Hello, please ask your question directly in the chat!",
        timestamp: new Date("2020-01-01T12:00:00"),
        agentInfo:
          '{"SecureKey":"c96899871e0c9bbfc33d","ChatId":"00135aJTHBPN0463","UserId":"020265AEC906019C","Alias":"514","NextPosition":8}',
      },
      {
        messageType: ChatAppMessageType.Agent,
        message: "Please keep in mind not to share personal information unless I ask for it.",
        timestamp: new Date("2022-11-01T12:00:00"),
        agentInfo:
          '{"SecureKey":"c96899871e0c9bbfc33d","ChatId":"00135aJTHBPN0463","UserId":"020265AEC906019C","Alias":"514","NextPosition":8}',
      },
      {
        messageType: ChatAppMessageType.User,
        message: "Ok, I have a question about my electricity bill.",
        timestamp: new Date("2022-11-01T16:00:00"),
        agentInfo:
          '{"SecureKey":"c96899871e0c9bbfc33d","ChatId":"00135aJTHBPN0463","UserId":"020265AEC906019C","Alias":"514","NextPosition":8}',
      },
      {
        messageType: ChatAppMessageType.Agent,
        message: "Alright, what's the question?",
        timestamp: new Date(),
        agentInfo:
          '{"SecureKey":"c96899871e0c9bbfc33d","ChatId":"00135aJTHBPN0463","UserId":"020265AEC906019C","Alias":"514","NextPosition":8}',
      },
    ],
  },
  options: {
    action: "dialog",
    open: true,
    messages: [
      {
        messageType: ChatAppMessageType.Bot,
        message: "Hello, let me suggest a couple of things for you.",
      },
      {
        messageType: ChatAppMessageType.Options,
        options: [
          {
            label: "Invoice",
          },
          {
            label: "Consumption",
          },
        ],
      },
    ],
  },
  links: {
    action: "links",
    open: true,
    messages: [
      {
        messageType: ChatAppMessageType.Bot,
        message: "Hello, let me suggest a couple of links for you.",
      },
      {
        messageType: ChatAppMessageType.Links,
        links: [
          {
            label: "Prices",
            href: "https://www.vattenfall.se/elavtal/elpriser/",
          },
          {
            label: "Solar",
            href: "https://www.vattenfall.se/solceller/",
          },
        ],
      },
    ],
  },
  download: {
    action: "download",
    open: true,
    messages: [
      {
        messageType: ChatAppMessageType.Bot,
        message: "Hello, How can I help you?.",
        timestamp: new Date(new Date().getTime() - 1000 * 14),
      },
      {
        messageType: ChatAppMessageType.User,
        message: "Can you send me my latest invoice please?",
        timestamp: new Date(new Date().getTime() - 1000 * 13),
      },
      {
        messageType: ChatAppMessageType.Bot,
        message: "Sure hold on, I'm sending it to you now.",
        timestamp: new Date(new Date().getTime() - 1000 * 10),
      },
      {
        messageType: ChatAppMessageType.Download,
        fileUrl: "https://localhost",
        fileName: "august-2022.pdf",
        fileSize: 96.8,
      },
    ],
  },
  switchToAgent: {
    action: "switch-to-agent",
    open: true,
    messages: [
      {
        messageType: ChatAppMessageType.Bot,
        message: "Hello, this is a bot talking.",
        timestamp: new Date(new Date().getTime() - 1000 * 15),
      },
      {
        messageType: ChatAppMessageType.SwitchAgent,
        message: "Now a agent at Customer Service will take over the conversation. Have a great day.",
        timestamp: new Date(new Date().getTime() - 1000 * 14),
      },
      {
        messageType: ChatAppMessageType.Agent,
        message:
          "Hello Daniel. My name is Håkan Gillman. Sorry that you had to wait that long. I see that you had a question about changing your contract to Hourly spot .",
        timestamp: new Date(new Date().getTime() - 1000 * 10),
      },
    ],
  },
  switchToBot: {
    action: "switch-to-bot",
    open: true,
    messages: [
      {
        messageType: ChatAppMessageType.Agent,
        message: "Hello, this is an agent talking.",
        timestamp: new Date(new Date().getTime() - 1000 * 15),
      },
      {
        messageType: ChatAppMessageType.SwitchBot,
        message: "The agent ended the conversation.",
        timestamp: new Date(new Date().getTime() - 1000 * 14),
      },
    ],
  },
  warning: {
    action: "message-warning",
    open: true,
    messages: [
      {
        messageType: ChatAppMessageType.Warning,
        message: "Sorry something went wrong. I could not connect to an agent.",
        timestamp: new Date(new Date().getTime() - 1000 * 10),
      },
    ],
  },
};
